import { ToggleButtonGroup, ToggleButton } from "@mui/material";

export type TriStateOption<T> = {
  value: T;
  label: string;
  activeColor?: string;
};

type PropTypes<T> = {
  value?: T;
  setValue: (type: string, newValue: T) => void;
  type: string;
  options: TriStateOption<T>[];
  align?: string;
  disabled?: boolean;
};

export default function TriStateSwitch<T>({
  value,
  setValue,
  type,
  options,
  align = "flex-end",
  disabled = false,
}: PropTypes<T>) {
  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={value}
      onChange={(e, newValue: T) => {
        if (newValue !== null) {
          setValue(type, newValue);
        }
      }}
      exclusive
      aria-label="Tri-state selector"
      style={{ alignSelf: align }}
      disabled={disabled}
    >
      {options.map((option, index) => (
        <ToggleButton
          key={index}
          sx={{ px: 1.25, minWidth: 60 }}
          style={
            value === option.value
              ? { 
                  background: option.activeColor || "#1976D2", 
                  color: "white" 
                }
              : { color: "#333" }
          }
          value={option.value as any}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
